import { Breadcrumb, Icon } from 'semantic-ui-react'
import { useCookies } from 'react-cookie'

import { useAppSelector } from 'redux/hooks'

import Link from 'components/elements/Link'

const FolderBreadcrumbs = () => {
  const parentFolder = useAppSelector(state => state.folders.rootFolder.parentFolder)
  const ownerId = useAppSelector(state => state.folders.rootFolder.owner.id)
  const privateFolder = useAppSelector(state => state.folders.rootFolder.private)
  const name = useAppSelector(state => state.folders.rootFolder.name)

  const [{ tbId: userId, tbRootFolder: rootFolder }] = useCookies(['tbId', 'tbRootFolder'])

  return (
    <Breadcrumb size="big" style={{ margin: '1rem 0' }}>
      {!parentFolder && <Breadcrumb.Divider icon="right chevron" />}
      {`${ownerId}` === `${userId}` && !!parentFolder && (
        <>
          <Breadcrumb.Section>
            <Link href={`/folders/${rootFolder}`}>Home</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right chevron" />
        </>
      )}
      {!!parentFolder && `${parentFolder.id}` !== `${rootFolder}` && (
        <>
          <Breadcrumb.Section>..</Breadcrumb.Section>
          <Breadcrumb.Divider icon="right chevron" />
        </>
      )}
      {!!parentFolder && `${parentFolder.id}` !== `${rootFolder}` && (
        <>
          <Breadcrumb.Section>
            <Link href={`/folders/${parentFolder.id}`}>{parentFolder.name}</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right chevron" />
        </>
      )}
      <Breadcrumb.Section active>
        {privateFolder && <Icon name="lock" />} {name}
      </Breadcrumb.Section>
    </Breadcrumb>
  )
}

export default FolderBreadcrumbs
